import { type ReactNode } from 'react';
import { ConfirmButtons } from './creator-delete-confirm';

type RestoreProps = {
  onConfirm: () => void;
  onCancel: () => void;
  isPending: boolean;
  paidPeriodWarning?: boolean;
};

function RestoreNote({
  paidPeriodWarning,
}: {
  paidPeriodWarning: boolean | undefined;
}): ReactNode {
  if (paidPeriodWarning) {
    return (
      <p className="rounded-md bg-surface-elevated p-sm text-xs text-brand-red">
        Este creador es de una semana ya pagada. Restaurarlo lo trae de vuelta a
        tu lista pero no recuperará pagos pasados.
      </p>
    );
  }
  return (
    <p className="text-xs text-text-secondary">
      Volverá a aparecer en tu lista y a contar para tus stats.
    </p>
  );
}

export function CreatorRestoreConfirm({
  onConfirm,
  onCancel,
  isPending,
  paidPeriodWarning,
}: RestoreProps): ReactNode {
  return (
    <div className="flex flex-col gap-sm border-t border-white/[0.06] pt-base">
      <RestoreNote paidPeriodWarning={paidPeriodWarning} />
      <ConfirmButtons
        onCancel={onCancel}
        onConfirm={onConfirm}
        isPending={isPending}
        label="Restaurar"
        variant="primary"
      />
    </div>
  );
}
